module.exports = __webpack_public_path__ + "static/media/iconWrite2.0758b0d0.svg";